<template>
    <CadastroPadrao :cabecalho="state.cabecalho" :linhas="state.linhas" :url="state.url" :titulo="state.titulo"
        :limparInput="limparInput" :objeto="state.objetoAuxiliar" :lstObrigatorios="state.lstObrigatorios"
        :lstObrigatoriosLabel="state.lstObrigatoriosLabel">
        <template v-slot:ficha>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Código
                </label>
                <div class="col inp">
                    <input type="text" class="form-control" v-model="state.objetoAuxiliar.id" disabled>
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Número de Série
                </label>
                <div class="col inp">
                    <input type="text" class="form-control" v-model="state.objetoAuxiliar.numSerie"
                        placeholder="Número de Série">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Ativo
                </label>
                <div class="col inp">
                    <input type="checkbox" class="form-check-input" v-model="state.objetoAuxiliar.ativo">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Tem Bateria
                </label>
                <div class="col inp">
                    <input type="checkbox" class="form-check-input" v-model="state.objetoAuxiliar.possuiBateria">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Bateria
                </label>
                <div class="col inp">
                    <input type="number" class="form-control" v-model="state.objetoAuxiliar.bateria"
                        :disabled="!state.objetoAuxiliar.possuiBateria">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Leito
                </label>
                <div class="col inp">
                    <select name="" id="" class="form-select" v-model="state.objetoAuxiliar.leito">
                        <option v-for="l in state.leitos" :key="l" :value="l"> {{ l.descricaoCompleta }} </option>
                    </select>
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Tipo Chamado
                </label>
                <div class="col inp">
                    <select name="" id="" class="form-select" v-model="state.objetoAuxiliar.tipoChamado">
                        <option v-for="t in state.tipoChamados" :key="t" :vatue="t"> {{ t.descricao }} </option>
                    </select>
                </div>
            </div>
        </template>
    </CadastroPadrao>
</template>

<script setup>
import CadastroPadrao from '@/components/CadastroPadrao.vue';
import { frontUrl } from "@/api/const";
import store from '@/store/store';
import api from '@/api/api';
import { reactive, onMounted, computed } from 'vue';

const state = reactive({
    cabecalho: ['Código', 'Ativo', 'Número de Série', 'Leito', 'Tipo Chamado'],
    linhas: ['id', 'ativo', 'numSerie', 'leito', 'tipoChamado'],
    url: "Equipamento",
    titulo: "Cadastro de Equipamentos",
    objetoAuxiliar: {
        id: Number(),
        ativo: Boolean(),
        data: new Date(),
        hora: String(),
        dtAtualizacao: new Date(),
        hrAtualizacao: String(),
    },
    link: frontUrl,
    leitos: [],
    tipoChamados: [],
    lstObrigatorios: ['numSerie', 'leito', 'tipoChamado'],
    lstObrigatoriosLabel: ['Número de Série', 'Leito', 'Tipo de Chamado'],
});

onMounted(async () => {
    await api.listaDinamica("/api/leito/listar?exibirAtivos=true")
        .then(resp => {
            state.leitos = resp;
        });
    await api.listaDinamica("/api/tipoChamado/listar?exibirAtivos=true")
        .then(resp => {
            state.tipoChamados = resp;
        });
});

async function limparInput(pObj) {
    if (pObj) {
        state.objetoAuxiliar = pObj;
    } else {
        state.objetoAuxiliar = {};
        let maiorId = 0;
        setor.value.forEach(s => {
            if (maiorId < s.id) {
                maiorId = s.id;
            }
        });
        state.objetoAuxiliar.id = maiorId + 1;
        state.objetoAuxiliar.ativo = true;
        state.objetoAuxiliar.data = new Date();
        state.objetoAuxiliar.hora = String();
        state.objetoAuxiliar.dtAtualizacao = new Date();
        state.objetoAuxiliar.hrAtualizacao = new Date();
    }
}

const setor = computed(() => {
    return store.state.setores;
});

const tipoChamado = computed(() => {
    return store.state.tipoChamado;
});
</script>

<style scoped>
.lbl {
    max-width: 35%;
    line-height: 35px;
}
</style>